import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import {
	IEditSubcategoryContext,
	EditSubcategoryContext,
} from '../../../../editSubcategoryState/editSubcategoryContext';

import { CustomerSelect } from './components/CustomerSelect';
// import { RestaurantsMultipleSelect } from './components/RestaurantsMultipleSelect';
import { RestaurantsByCategoryMultipleSelect } from './components/RestaurantsByCategoryMultipleSelect';
import { NameSubcategoryInput } from './components/NameSubcategoryInput';
import { CategorySelect } from './components/CategorySelect';
import { HasSchedulePriorityCheckBox } from './components/HasSchedulePriorityCheckBox';
import { ActivationScheduleInput } from './components/ActivationScheduleInput';
import { DeactivationScheduleInput } from './components/DeactivationScheduleInput';
import CronGenerator from 'components/CronGenerator/CronGenerator';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';
import { BtnBlock } from './components/BtnBlock';
import { Form } from 'antd';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { getFileIdForSubmit, preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setIDCustomer,
		setFetchedCustomers,
		setIDsRestaurant,
		setFetchedRestaurants,
		setFetchedCategories,
		setIDCategory,
		changeLoaderStatus,
		changeNameOfSubcategory,
		toggleHasSchedulePriority,
		setDefaultCustomerLanguage,
		setTranslationTab,
		changeNameTranslation,
		changeActivationSchedule,
		changeDeactivationSchedule,
		isLoading,
		fileId,
		filePath,
		subcategoryID,
		IDSelectedCustomer,
		initialIDSelectedCustomer,
		IDsSelectedRestaurant,
		initialIDsSelectedRestaurant,
		nameOfSubcategory,
		initialIDSelectedCategory,
		IDSelectedCategory,
		hasSchedulePriority,
		activationSchedule,
		deactivationSchedule,
		translations,
		defaultCustomerLanguage,
		selectedTranslationTab,
	} = useContext<IEditSubcategoryContext>(EditSubcategoryContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			IDSelectedCustomer,
			IDsSelectedRestaurant,
			nameOfSubcategory,
			IDSelectedCategory,
			hasSchedulePriority,
			activationSchedule,
			deactivationSchedule,
		});
	}, [
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		nameOfSubcategory,
		IDSelectedCategory,
		hasSchedulePriority,
		activationSchedule,
		deactivationSchedule,
	]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		setDataForSubmit({
			id: subcategoryID,
			name: nameOfSubcategory,
			fileId: getFileIdForSubmit({ fileId, filePath }),
			restaurantIds: IDsSelectedRestaurant,
			overrideScheduleAvailability: hasSchedulePriority,
			activationCron: activationSchedule || null,
			deactivationCron: deactivationSchedule || null,
			translations,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<div className={style.infoWrapper}>
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#circleInfoTransparent`} />
						</svg>
						<Text
							translationNameSpace="form"
							translationKey="warningBeforeSubcategoryChange"
							theme="secondary"
							size="s"
							display="inline"
						/>
					</div>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<NameSubcategoryInput changeNameOfSubcategory={changeNameOfSubcategory} />
					<CustomerSelect
						setIDCustomer={setIDCustomer}
						setFetchedCustomers={setFetchedCustomers}
						initialIDSelectedCustomer={initialIDSelectedCustomer}
					/>
					<CategorySelect
						setFetchedCategories={setFetchedCategories}
						setIDCategory={setIDCategory}
						customerId={IDSelectedCustomer}
						initialIDSelectedCategory={initialIDSelectedCategory}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="translationsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<MenuTranslationForm
						className={style.translationForm}
						setDefaultCustomerLanguage={setDefaultCustomerLanguage}
						setTranslationTab={setTranslationTab}
						changeNameTranslation={changeNameTranslation}
						isShowLanguageName={false}
						IDSelectedCustomer={IDSelectedCustomer}
						translations={translations}
						selectedTranslationTab={selectedTranslationTab}
						nameLabel="nameSubcategoryLabel"
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="scheduleHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<HasSchedulePriorityCheckBox
						toggleHasSchedulePriority={toggleHasSchedulePriority}
						hasSchedulePriority={hasSchedulePriority}
					/>
					<div className={style.row}>
						<ActivationScheduleInput changeActivationSchedule={changeActivationSchedule} />
						<DeactivationScheduleInput changeDeactivationSchedule={changeDeactivationSchedule} />
					</div>
					<CronGenerator />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantListHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					{/* <RestaurantsMultipleSelect
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
						changeLoaderStatus={changeLoaderStatus}
						IDSelectedCustomer={IDSelectedCustomer}
						initialIDsSelectedRestaurant={initialIDsSelectedRestaurant}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/> */}
					<RestaurantsByCategoryMultipleSelect
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
						changeLoaderStatus={changeLoaderStatus}
						initialIDsSelectedRestaurant={initialIDsSelectedRestaurant}
						IDSelectedCategory={IDSelectedCategory}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
				</div>
				{!isLoading && <BtnBlock changeTypeOfModalWindow={changeTypeOfModalWindow} />}
			</Form>
		</div>
	);
};
